import Madewell from './assets/images/brands-logo/1_madewell.jpg'
import FreePeople from './assets/images/brands-logo/2_freepeople.jpg'
import Underarmour from './assets/images/brands-logo/3_underarmour.jpg'
import Mother from './assets/images/brands-logo/4_mother.jpg'
import GoodAmerican from './assets/images/brands-logo/5_goodamerican.jpg'
import Vincent from './assets/images/brands-logo/6_vince.jpg'
import Rails from './assets/images/brands-logo/7_rails.jpg'
import Aliceolivia from './assets/images/brands-logo/8_aliceolivia.jpg'

const data =[ 
    {img: Madewell},
    {img: FreePeople},
    {img: Underarmour},
    {img: Mother},
    {img: GoodAmerican},
    {img: Vincent},
    {img: Rails},
    {img: Aliceolivia},
    {img: Madewell},
    {img: FreePeople},
    {img: Underarmour},
    {img: Mother},
    {img: GoodAmerican},
    {img: Vincent},
    {img: Rails},
    {img: Aliceolivia},
    {img: Madewell},
    {img: FreePeople},
    {img: Underarmour},
    {img: Mother},
    {img: GoodAmerican},
    {img: Vincent},
    {img: Rails},
    {img: Aliceolivia},
    {img: Madewell},
    {img: FreePeople},
    {img: Underarmour},
    {img: Mother},
    {img: GoodAmerican},
    {img: Vincent},
    {img: Rails},
    {img: Aliceolivia},
]

export default data

